"use strict";

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n  .vg-tooltip {\n    visibility: hidden;\n    position: fixed;\n    z-index: 2000;\n    padding: 15px;\n    background-color: #FFF;\n    border-radius: 4px;\n    border: 1px solid rgba(26, 28, 34, 0.1);\n    box-shadow: 0 20px 30px 0 rgba(0, 0, 0, .1);\n    font-size: 14px;\n    font-family: 'Lato', 'Helvetica Neue', Helvetica, Arial, sans;;\n    color: #393f44;\n\n    tr {\n      td.key {\n        max-width: 150px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        padding-right: 20px;\n        color: #808080;\n      }\n\n      td.value {\n        max-width: 200px;\n        overflow: hidden;\n        text-overflow: ellipsis;\n        font-weight: 700;\n      }\n\n      &:first-of-type {\n        td.value {\n          font-size: 18px;\n        }\n      }\n    }\n  }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _styledComponents = require("styled-components");

var _default = (0, _styledComponents.createGlobalStyle)(_templateObject());

exports["default"] = _default;